/**
 * The upgrade-status endpoint reports `blocking: true` only while the workspace
 * is actually unavailable to users. Other in-progress upgrades keep serving, so
 * users must not be pushed to the upgrade page.
 */
export function shouldRedirectToUpgrade(data: unknown): boolean {
  if (typeof data !== 'object' || data === null) {
    return false
  }
  return (data as { blocking?: unknown }).blocking === true
}
